import styled from "styled-components";
import Theme from "../Theme/Theme";

export default class Utils {
  //*********************  TextField  *********************//
  static InputContainer = styled.div`
    height: max-content;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    margin-block: 5px;
  `;

  static InputWraper = styled.div`
    width: ${Theme.inputWidth};
    height: ${Theme.inputHeight};
    border-radius: ${Theme.borderRadius};
    position: relative;
  `;

  // InputTextField For All Pages
  static InputTextField = styled.input`
    width: ${Theme.inputWidth};
    height: ${Theme.inputHeight};
    border-radius: ${Theme.borderRadius};
    background-color: transparent;
    color: ${Theme.colorFontBlack};
    font-size: ${Theme.fontSize};
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding-right: 20px;
    padding-left: 40px;
    font-family: "IranSans" !important;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    font-weight: ${Theme.fontWeight};
    border: 1px solid ${Theme.colorBorderTextField};

    &:focus {
      border: 1px solid ${Theme.colorBorderTextField};
    }
  `;

  static InputTextFieldIcon = styled.img`
    position: absolute;
    top: 30%;
    left: 5%;
    width: 18px;
    height: 18px;
    object-fit: contain;
    background-color: transparent;
    cursor: ${(props) => (props.onClick != null ? "pointer" : "default")};
  `;

  // LabelTextField For All Pages
  static LabelTextField = styled.p`
    color: ${Theme.colorFontBlack};
    font-size: ${Theme.fontSize};
    font-weight: ${Theme.fontWeight};
  `;
  //*********************  TextField  *********************//

  //*********************  Button  *********************//
  static InputButton = styled.button`
    position: relative;
    width: ${(props) => props.width};
    height: ${Theme.inputHeight};
    border-radius: ${Theme.borderRadius};
    background-color: ${Theme.colorBluePrimary};
    color: ${Theme.colorFontWhite};
    font-size: ${Theme.fontSize};
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "IranSans" !important;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    font-weight: ${Theme.fontWeight};
    border: 0px solid transparent;
    cursor: pointer;
    transition: 300ms;
    overflow: hidden;

    &:hover {
      background-color: #0e16ad;
      box-shadow: rgb(19 28 233 / 50%) 0 1px 15px;
    }
  `;
  //*********************  Button  *********************//

  //*********************  LableButton  *********************//
  static LableButton = styled.button`
    background-color: ${Theme.colorIconButton};
    width: 50px;
    height: 50px;
    border: none;
    border-radius: ${Theme.borderRadius};
    margin: 5px 0 5px ${(props) => props.width};

    &:hover {
      background-color: ${Theme.colorBackgroundBoxHover};
      cursor: pointer;
    }
  `;
  //*********************  LableButton  *********************//

  //*********************  Icon  *********************//
  static Icon = styled.img`
    width: 30px;
    height: 30px;
  `;
  //*********************  Icon  *********************//
}
